import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import ItemScoringDef from './ItemScoringDef';
import authService from '../../services/AuthService';
import api, { apiErrorHandler } from '../../services/AxiosService';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class ItemScoringDefs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            domain: props.domain,
            scoringItems: null,
            scoreVariantOptions: null
        }

        this.itemScoreDefs = [];
    }

    itemScoringChangeHandler = (indexItemDefId, scoreVariant, asdScore, asdWeight, asdDomainScore, asdDomainWeight) => {
        let found = false;
        for (let i = 0; i < this.itemScoreDefs.length; i++) {
            if (this.itemScoreDefs[i].indexItemDefId === indexItemDefId) {
                // Found it.  Update the item
                found = true;
                this.itemScoreDefs[i].scoreVariant = scoreVariant;
                this.itemScoreDefs[i].asdScore = asdScore;
                this.itemScoreDefs[i].asdWeight = asdWeight;
                this.itemScoreDefs[i].asdDomainScore = asdDomainScore;
                this.itemScoreDefs[i].asdDomainWeight = asdDomainWeight
                break;
            }
        }

        if (!found) {
            this.itemScoreDefs.push({ indexItemDefId: indexItemDefId, scoreVariant: scoreVariant, asdScore: asdScore, asdWeight: asdWeight, asdDomainScore: asdDomainScore, asdDomainWeight: asdDomainWeight });
        }
        this.props.itemScoringChangeHandler(this.itemScoreDefs);
    }

    componentDidMount = () => {
        /*
         * Run a query to get the information for the domain specified in props (null is all domains).
         * The query returns a list of definitions. 
         */
        let domainName = (this.state.domain === null || this.state.domain === "") ? "All" : this.state.domain;

        let url = "admin/" + domainName + "/itemscoring";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })  
            .then((response) => {
                if (response.status == 200) {
                this.setState({
                    scoringItems: response.data.itemScoringModel,
                    scoreVariantOptions: response.data.scoreVariantOptions
                });
            }
        })
        .catch(error => {
            // Major problem - should not happen.  Back to login?
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    render() {
        // Build the table's rows.  
        let scoringItems = null;
        if (this.state.scoringItems != null) {
            scoringItems = this.state.scoringItems.map((item) => {
                return (
                    <ItemScoringDef
                        domainDefId={item.domainDefId}
                        domainName={item.domainName}
                        itemDefId={item.itemDefId}
                        indexItemDefId={item.indexItemDefId}
                        assessmentArea={item.assessmentArea}
                        scoreVariant={item.scoreVariant}
                        asdScore={item.asdScore}
                        asdWeight={item.asdWeight}
                        asdDomainScore={item.asdDomainScore}
                        asdDomainWeight={item.asdDomainWeight}
                        scoreVariantOptions={this.state.scoreVariantOptions}
                        changeHandler={this.itemScoringChangeHandler}
                    />
                );
            })
        }
        return (
            <Form>
                <Table striped bordered responsive size="sm">
                    <thead>
                        <tr>
                            <th>Domain</th>
                            <th>Assessment Area</th>
                            <th width="150">Score Variant</th>
                            <th width="70">ASD Scoring?</th>
                            <th width="70">ASD Weight</th>
                            <th width="150">ASD Domain Scoring?</th>
                            <th width="85">ASD Domain Weight</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scoringItems}
                    </tbody>
                </Table>
            </Form>
        );
    }
}

export default ItemScoringDefs;


// WEBPACK FOOTER //
// ./src/components/AdminHome/ItemScoringDefs.js